module.exports = __webpack_public_path__ + "static/media/constant_number_white.8a14c917.svg";